var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRightChevIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 500,
    zoomAndPan: "magnify",
    viewBox: "0 0 375 374.999991",
    height: 500,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    transform: "matrix(0.517956, 0.542422, -0.542422, 0.517956, 69.486161, -0.0970926)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M 12.999561 12.999842 L 333.153775 13.002885 ",
    stroke: "#000000",
    strokeWidth: 26,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    transform: "matrix(0.529582, -0.531077, 0.531077, 0.529582, 55.531671, 355.092077)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M 12.998592 13.001542 L 326.519751 13.001248 ",
    stroke: "#000000",
    strokeWidth: 26,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightChevIcon);
export default __webpack_public_path__ + "static/media/right-chev-icon.9997ac82476cee51220bdb5cb353728a.svg";
export { ForwardRef as ReactComponent };